import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import {
  MainWrapper,
  MainContainer,
  Heading3,
  Paragraph,
} from '../main.style'

import { Loader } from '../../components/loader';
import InputField from '../../components/inputField'

const Update = ({ customerEmail }) => {
  const { t } = useTranslation();
  const [loader, setLoader] = useState(true)

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    setTimeout(() => {
      setLoader(false)
    }, 500);
  }, [])

  return (
    <>
      {loader && <Loader isFullScreen={true} />}
      <MainWrapper>
        <MainContainer>
          <Heading3>{t('epc_upgrade_content.header')}</Heading3>
          <Paragraph width="424px">
            {t('epc_upgrade_content.content')}
          </Paragraph>
          <InputField
            type="email"
            name="email"
            setValue={customerEmail}
            id="email"
            placeHolder={customerEmail}
            readOnly="readonly"
          />
        </MainContainer>
      </MainWrapper>
    </>
  )
}

export default Update
